<!--The content below is only a placeholder and can be replaced.-->
    <header class='s18-header-style'>
        <s18-header></s18-header>
    </header>
    <main class='s18-main-style' style='margin-top:65px'>
        <router-outlet></router-outlet>
    </main>
    <footer [class.footer-collapsed]="footerCollapsed">
        <s18-footer></s18-footer>
    </footer>
